import {
  Content,
  PageWithHeader,
  ResponseErrorPanel,
} from '@backstage/core-components';
import { attachComponentData } from '@backstage/core-plugin-api';
import { useTranslationRef } from '@backstage/core-plugin-api/alpha';
import { CatalogFilterLayout } from '@backstage/plugin-catalog-react';
import {
  NotificationsTable,
  notificationsPlugin,
  notificationsTranslationRef,
} from '@backstage/plugin-notifications';
import { makeStyles } from '@material-ui/core/styles';
import { CustomNotificationsFilters } from './CustomNotificationsFilters';
import { useNotificationsPage } from './useNotificationsPage';

const useStyles = makeStyles(theme => ({
  content: {
    // Reserve the same content-header space as the Catalog index.
    paddingTop: theme.spacing(10),
    [theme.breakpoints.down('xs')]: {
      paddingTop: theme.spacing(3),
    },
  },
  table: {
    minWidth: 0,
    '& [class*="BackstageTableToolbar-root"]': {
      minHeight: theme.spacing(10),
    },
    '& [id^="notification-"] .bui-Text': {
      fontFamily: theme.typography.fontFamily,
    },
  },
}));

export const CustomNotificationsPage = () => {
  const classes = useStyles();
  const { t } = useTranslationRef(notificationsTranslationRef);
  const { filters, table, error } = useNotificationsPage();

  if (error) {
    return <ResponseErrorPanel error={error} />;
  }

  return (
    <PageWithHeader title={t('notificationsPage.title')} themeId="home">
      <Content className={classes.content}>
        <CatalogFilterLayout>
          <CatalogFilterLayout.Filters>
            <CustomNotificationsFilters {...filters} />
          </CatalogFilterLayout.Filters>
          <CatalogFilterLayout.Content>
            <div className={classes.table}>
              <NotificationsTable {...table} />
            </div>
          </CatalogFilterLayout.Content>
        </CatalogFilterLayout>
      </Content>
    </PageWithHeader>
  );
};

// Preserve plugin API and route discovery through convertLegacyAppRoot.
attachComponentData(
  CustomNotificationsPage,
  'core.plugin',
  notificationsPlugin,
);
attachComponentData(
  CustomNotificationsPage,
  'core.mountPoint',
  notificationsPlugin.routes.root,
);
